import styled from "styled-components";
import { Box, Card, Grid } from "@mui/material";

export const GridContainer = styled(Grid)`
	padding: 20px 10px;
	padding-bottom: 100px;
	position: relative;
	.MuiPaper-root {
		height: unset;
	}
`;

export const LockedOverviewWrapper = styled(Box)`
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 40px 20px;

	.icon_ring {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: radial-gradient(circle at 30% 30%, #fdf3d0, #f0d78a 60%, #c9a84c 100%);
		box-shadow: 0 8px 30px rgba(201, 168, 76, 0.35);
		margin-bottom: 14px;

		svg {
			font-size: 34px;
			color: #8b6914;
		}
	}

	.views_value {
		font-size: clamp(48px, 8vw, 72px);
		font-weight: 800;
		line-height: 1;
		background: linear-gradient(135deg, #8b6914, #c9a84c);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.views_label {
		font-weight: 700;
		font-size: 13px;
		color: ${({ theme }) => theme.palette.text.secondary};
		text-transform: uppercase;
		letter-spacing: 1.2px;
		margin-top: 8px;
	}

	.teaser_text {
		max-width: 380px;
		color: ${({ theme }) => theme.palette.text.secondary};
		margin: 18px 0 24px;
	}

	.locked_row {
		display: flex;
		gap: 14px;
		margin-bottom: 26px;
	}

	.locked_stat {
		position: relative;
		width: 46px;
		height: 46px;
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: ${({ theme }) => theme.palette.grey[100]};
		color: ${({ theme }) => theme.palette.grey[400]};

		svg:first-child {
			font-size: 20px;
		}

		.lock_badge {
			position: absolute;
			bottom: -6px;
			right: -6px;
			width: 16px;
			height: 16px;
			padding: 2px;
			border-radius: 50%;
			background: #c9a84c;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px !important;
			box-shadow: 0 0 0 2px #fff;
		}
	}
`;

export const StatWrapper = styled(Card)<{ $statColor: string }>`
	padding: 16px 18px;
	display: flex;
	align-items: flex-start;
	gap: 14px;
	min-width: 185px;

	flex: 1;
	border-left: 4px solid ${({ $statColor }) => $statColor} !important;
	transition:
		transform 0.15s ease,
		box-shadow 0.15s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
	}

	${props => props.theme.breakpoints.down("md")} {
		width: 100%;
	}

	.icon {
		width: 44px;
		height: 44px;
		border-radius: 10px;
		background: ${({ $statColor }) => $statColor}22;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;

		svg {
			fill: ${({ $statColor }) => $statColor};
			font-size: 20px;
		}
	}

	.stats {
		display: flex;
		flex-direction: column;
	}
`;
